'use client'
import React, {useContext, useEffect, useState} from 'react';
import {Controller, useFieldArray, useForm} from 'react-hook-form';
import {Flex} from '@chakra-ui/layout';
import {Button, Input} from '@chakra-ui/react';
import {IconButton} from '@chakra-ui/button';
import {MdAdd, MdCheck, MdClose, MdDelete} from 'react-icons/md';
import {forwardRef} from '@chakra-ui/system';
import useProductsApi from '../../lib/useProductsApi';
import { ProductContext } from '../../lib/productContext';
const ProductAsideMainFeaturesForm = forwardRef((props, ref) => {
  const {
    product,
    productId,
    refresh,
  } = useContext(ProductContext);
  const {
    hideSave,
    onValidityChange,
    onSubmitted,
    onSubmitting,
    onCancel
  } = props;
  const [localFields, setLocalFields] = useState([]);
  const [hiddenFields, setHiddenFields] = useState([]);
  const {
    handleSubmit,
    errors,
    control,
    register,
    setValue,
    watch,
    reset,
    formState: { isSubmitting, isValid }
  } = useForm({
    mode: 'onChange'
  });
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: 'features',
  });
  const watchedFeatures = watch('features');
  const productApi = useProductsApi();
  const onSubmit = async (data) => {
    try {
      if(onSubmitting) {
        onSubmitting();
      }
      if(product.id && data.features) {
        const filteredFeatures = data.features.filter((feature, index) => 
          !hiddenFields.includes(index) && 
          feature && feature.trim() !== ''
        );
        await productApi.updateFeatures(
          filteredFeatures,
          product.id
        )
        await refresh();
      }
      if(onSubmitted) {
        onSubmitted();
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    if(product.features && product.features.length > 0) {
      reset({ features: product.features });
      setLocalFields(product.features);
    } else {
      reset({ features: [''] });
      setLocalFields(['']);
    }
    setHiddenFields([]);
  }, [product, reset]);
  useEffect(() => {
    if(onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid]);
  return (
    <>
      <Flex alignSelf={"stretch"}  w={"100%"} flexDirection={"column"} gap={2}>
        <form style={{width:'100%'}} onSubmit={handleSubmit(onSubmit)} >
          <Flex
            alignItems={'stretch'}
            flexDirection={'column'}
            gap={2}
          >
            {localFields.map((item, i) => 
              !hiddenFields.includes(i) ? (
                <Flex
                  key={i}
                  gap={2}
                  alignItems={"center"}
                  >
                <Controller
                  name={`features[${i}]`}
                  control={control}
                  defaultValue={item}
                  render={({ field }) => (
                    <Input
                      placeholder='Feature…'
                      {...field}
                    />
                  )}
                />
              <IconButton
              variant="redOutline"
              icon={<MdDelete />}
              onClick={() => {
                if (localFields.length > 1) {
                  const newFields = [...localFields];
                  newFields.splice(i, 1);
                  setLocalFields(newFields);
                  remove(i);
                } else {
                  setHiddenFields([...hiddenFields, i]);
                }
              }}
              mr={1}
              />
              </Flex>
              ) : null
            )}
            <Button
              type="button"
              alignSelf={"flex-start"}
              variant="purpleTransparent"
              leftIcon={<MdAdd/>}
              onClick={() => {
                setLocalFields([...localFields, '']);
                append('');
              }}
              isDisabled={false}
            >Add Feature</Button>
            <Flex display={"flex"} gap={2}>
              {onCancel && (
                <IconButton
                  variant="greyOutline"
                  icon={<MdClose />}
                  onClick={onCancel}
                />
              )}
              <IconButton
                style={{
                  display: hideSave ? 'none' : 'inherit',
                }}
                ref={ref}
                icon={<MdCheck />}
                type={'submit'}
                aria-label='check'
                variant='purpleOutline'
                isLoading={isSubmitting}
                isDisabled={!isValid}
              />
            </Flex>
          </Flex>
        </form>
      </Flex>
    </>
  );
});
export default ProductAsideMainFeaturesForm;
